var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBtnVisible),expression:"isBtnVisible"}]},[_c('button',{staticClass:"backToTopBtn btn btn-primary btn-sm",attrs:{"type":"button "},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-arrow-up"}),_c('p',{staticClass:"mb-0 text-white"},[_vm._v("TOP")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }